import { render, staticRenderFns } from "./boadduser.vue?vue&type=template&id=104fd5bf&scoped=true"
import script from "./boadduser.vue?vue&type=script&lang=js"
export * from "./boadduser.vue?vue&type=script&lang=js"
import style0 from "./boadduser.vue?vue&type=style&index=0&id=104fd5bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104fd5bf",
  null
  
)

export default component.exports